var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"byRegion",staticStyle:{"min-height":"650px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }